import React from 'react';
import { Button } from '@tranquility-ai/theme-components/button';

import { ChatAttachmentFileIcon } from './chat-attachment-icon';
import type { ChatAttachment } from '@/shared/types';

interface AttachmentListProps {
  attachments: ChatAttachment[];
  onDownload: (attachment: ChatAttachment) => void;
}

function formatAttachmentSize(bytes: number): string {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function AttachmentList({ attachments, onDownload }: AttachmentListProps) {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div
      data-testid="ChatAttachments"
      className="flex flex-col gap-1 px-2 lg:px-4 pb-3 pt-1 mt-[-4px] border-t-[1px] border-white/10"
    >
      <span className="text-white/60 text-[12px] self-start">
        Generated files:
      </span>
      <div className="box-border flex flex-row flex-wrap gap-2 max-h-[56px] sm:max-h-[72px] overflow-y-auto custom-scrollbar2">
        {attachments.map((attachment) => (
          <Button
            key={attachment.s3_key}
            type="button"
            size="sm"
            style="outline"
            color="light"
            background="inverse"
            data-testid="ChatAttachmentChip"
            onClick={() => onDownload(attachment)}
            className="flex flex-row items-center gap-2 px-3 py-1 rounded-full bg-white/10 hover:bg-white/20
              text-white text-[12px] cursor-pointer border-[1px] border-white/20"
            title={`Download ${attachment.filename} (${formatAttachmentSize(attachment.size_bytes)})`}
          >
            <span className="inline-flex min-w-0 items-center gap-2">
              <ChatAttachmentFileIcon filename={attachment.filename} />
              <span className="min-w-0 truncate">{attachment.filename}</span>
              <span className="shrink-0 text-white/50 text-[10px]">
                {formatAttachmentSize(attachment.size_bytes)}
              </span>
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
}
